// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__Bx1GE","log":"ModalInventoryLogs_log__3jmQE","date":"ModalInventoryLogs_date__1RRH-","userName":"ModalInventoryLogs_userName__8W_OZ"};